import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyAXDMcNZ1qHcsmZoIq4xKWcI68ETWT4JpE",
  authDomain: "glowaura-web.firebaseapp.com",
  projectId: "glowaura-web",
  storageBucket: "glowaura-web.firebasestorage.app",
  messagingSenderId: "1096072213207",
  appId: "1:1096072213207:web:3e359b52baa52d73ee7692"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app)